import React from "react";
import { useOrderChecklistQuery } from "@queries/website";

/**
 * Pre-service checklist answers captured at order time (e.g. car-cleaning:
 * seater type, water / electricity / garage availability). Renders nothing
 * when the order has no checklist, so non on-site orders are unaffected.
 * Shown on the job sheet so the crew brings the right gear.
 */
export default function OrderChecklist({ orderId }) {
  const { data } = useOrderChecklistQuery(orderId);

  if (!data || data.length === 0) return null;

  const warnings = data
    .filter((row) => row.answer_key === "no")
    .map((row) => {
      switch (row.question_key) {
        case "water_source":
          return "No on-site water — bring a water tank.";
        case "electricity":
          return "No electricity source — bring a generator.";
        case "garage":
          return "No garage — plan for an outdoor setup.";
        default:
          return null;
      }
    })
    .filter(Boolean);

  return (
    <div className="card" style={{ marginBottom: "20px" }}>
      <div className="card-header">
        <h2>Pre-Service Checklist</h2>
      </div>
      <div className="card-body">
        <table style={{ width: "100%", fontSize: 13 }}>
          <tbody>
            {data.map((row) => (
              <tr key={row.id}>
                <td style={{ padding: "4px 8px 4px 0", color: "#555", width: 240 }}>
                  {row.question_label}
                  {row.question_label_ar ? (
                    <span dir="rtl" style={{ color: "#2563eb" }}> · {row.question_label_ar}</span>
                  ) : null}
                </td>
                <td style={{ padding: "4px 0", fontWeight: 600 }}>
                  {row.answer_label}
                  {row.answer_label_ar ? (
                    <span dir="rtl" style={{ color: "#2563eb", fontWeight: 400 }}> · {row.answer_label_ar}</span>
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {warnings.length > 0 && (
          <div
            style={{
              marginTop: 10,
              padding: "8px 12px",
              background: "#fef3c7",
              border: "1px solid #f59e0b",
              borderRadius: 6,
              fontSize: 13
            }}
          >
            {warnings.map((w) => (
              <div key={w}>⚠ {w}</div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
